import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import NewTournamentContainer from "../../containers/NewTournamentContainer";
import ResultsContainer from "../../containers/results/ResultsContainer";
import ScheduleContainer from "../../containers/schedule/ScheduleContainer";
import GeneralContainer from "../../containers/settings/GeneralContainer";
import StructureContainer from "../../containers/structure/StructureContainer";
import ParticipantsTabs from "../ParticipantsTabs";
import SettingsTabs from "../settings/SettingsTabs";

export const TournamentRoutes = (props) => (
  <Switch>
    <Route
      path="/tournament/:tournamentId/new"
      exact
      render={() => (
        <NewTournamentContainer
          tournament={props.tournament}
          divisions={props.divisions}
          divisionsObject={props.divisionsObject}
          tournamentStatus={props.tournamentStatus}
          userStatus={props.userStatus}
          tournamentAdmin={props.tournamentAdmin}
          user={props.user}
          setAuthListener={props.setAuthListener}
        />
      )}
    />
    <Route
      path="/tournament/:tournamentId/new/:psdCode"
      exact
      render={(path) => (
        <NewTournamentContainer
          tournament={props.tournament}
          divisions={props.divisions}
          divisionsObject={props.divisionsObject}
          tournamentStatus={props.tournamentStatus}
          userStatus={props.userStatus}
          tournamentAdmin={props.tournamentAdmin}
          user={props.user}
          psdCode={path.match.params.psdCode}
          setAuthListener={props.setAuthListener}
        />
      )}
    />
    <Route
      path="/tournament/:tournamentId/settings"
      exact
      render={() => (
        <GeneralContainer
          tournament={props.tournament}
          divisions={props.divisions}
          divisionsObject={props.divisionsObject}
          userStatus={props.userStatus}
          tournamentStatus={props.tournamentStatus}
          user={props.user}
          userData={props.userData}
          tournamentAdmin={props.tournamentAdmin}
        />
      )}
    />
    <Route
      path="/tournament/:tournamentId/signup"
      exact
      render={() => (
        <SettingsTabs
          tournament={props.tournament}
          divisions={props.divisions}
          divisionsObject={props.divisionsObject}
          userStatus={props.userStatus}
          tournamentStatus={props.tournamentStatus}
          user={props.user}
          tournamentAdmin={props.tournamentAdmin}
          userData={props.userData}
          signup={true}
        />
      )}
    />
    <Route
      path="/tournament/:tournamentId/info"
      exact
      render={() => (
        <SettingsTabs
          tournament={props.tournament}
          divisions={props.divisions}
          divisionsObject={props.divisionsObject}
          userStatus={props.userStatus}
          tournamentStatus={props.tournamentStatus}
          user={props.user}
          tournamentAdmin={props.tournamentAdmin}
          userData={props.userData}
          tournamentInfo={true}
        />
      )}
    />
    <Route
      path="/tournament/:tournamentId"
      exact
      render={() => (
        <SettingsTabs
          tournament={props.tournament}
          divisions={props.divisions}
          divisionsObject={props.divisionsObject}
          userStatus={props.userStatus}
          tournamentStatus={props.tournamentStatus}
          user={props.user}
          tournamentAdmin={props.tournamentAdmin}
          userData={props.userData}
        />
      )}
    />

    <Route
      path="/tournament/:tournamentId/upgrade"
      exact
      render={() => (
        <SettingsTabs
          tournament={props.tournament}
          divisions={props.divisions}
          divisionsObject={props.divisionsObject}
          userStatus={props.userStatus}
          tournamentStatus={props.tournamentStatus}
          upgrade={true}
          user={props.user}
          userData={props.userData}
        />
      )}
    />
    <Route
      path="/tournament/:tournamentId/teams/referees"
      exact
      render={() => (
        <ParticipantsTabs
          tournament={props.tournament}
          divisions={props.divisions}
          divisionsObject={props.divisionsObject}
          tournamentStatus={props.tournamentStatus}
          tournamentAdmin={props.tournamentAdmin}
          user={props.user}
          index={1}
        />
      )}
    />
    <Route
      path="/tournament/:tournamentId/prosoccerdata"
      exact
      render={() => (
        <ParticipantsTabs
          tournament={props.tournament}
          divisions={props.divisions}
          divisionsObject={props.divisionsObject}
          tournamentStatus={props.tournamentStatus}
          tournamentAdmin={props.tournamentAdmin}
          user={props.user}
          prosoccerdata={true}
        />
      )}
    />

    <Route
      path="/tournament/:tournamentId/teams"
      exact
      render={() => (
        <ParticipantsTabs
          tournament={props.tournament}
          divisions={props.divisions}
          divisionsObject={props.divisionsObject}
          tournamentStatus={props.tournamentStatus}
          tournamentAdmin={props.tournamentAdmin}
          user={props.user}
        />
      )}
    />
    <Route
      path="/tournament/:tournamentId/structure"
      exact
      render={() => (
        <StructureContainer
          tournament={props.tournament}
          divisions={props.divisions}
          divisionsObject={props.divisionsObject}
          userStatus={props.userStatus}
          tournamentStatus={props.tournamentStatus}
          user={props.user}
          tournamentAdmin={props.tournamentAdmin}
          userData={props.userData}
        />
      )}
    />
    <Route
      path="/tournament/:tournamentId/schedule"
      exact
      render={() => (
        <ScheduleContainer
          tournament={props.tournament}
          divisions={props.divisions}
          divisionsObject={props.divisionsObject}
          tournamentStatus={props.tournamentStatus}
          tournamentAdmin={props.tournamentAdmin}
          supportOpen={props.supportOpen}
          handleDrawerClose={props.handleDrawerClose}
          userData={props.userData}
          user={props.user}
          userStatus={props.userStatus}
        />
      )}
    />
    <Route
      path="/tournament/:tournamentId/results"
      exact
      render={() => (
        <ResultsContainer
          tournament={props.tournament}
          divisions={props.divisions}
          divisionsObject={props.divisionsObject}
          tournamentStatus={props.tournamentStatus}
          tournamentAdmin={props.tournamentAdmin}
          userData={props.userData}
          user={props.user}
        />
      )}
    />
    <Route path="*" render={() => <Redirect to="/" />} />
  </Switch>
);
